import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get, sortBy } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { buildSubmodelsPath, VehicleGraphQLModel } from 'client/data/models/vehicle-graphql';
import { CorePageParams } from 'site-modules/shared/utils/core-page/params';
import { getCoreUrl } from 'site-modules/shared/utils/core-link-constructor';
import { Link } from 'site-modules/shared/components/link/link';

import './other-submodels.scss';

export function OtherSubmodelsUI({
  params,
  submodels = null,
  currentSubmodelId = null,
  heading = null,
  className = null,
}) {
  if (get(submodels, 'length', 0) < 2) {
    return null;
  }

  const submodelsArray = sortBy(
    submodels.map(({ slug, name }) => ({
      slug,
      value: name,
      id: `${params.year}|${slug}`,
    })),
    ({ id }) => id !== currentSubmodelId
  );

  return (
    <div className={classnames('other-submodels', className)} data-tracking-parent="submodel_links">
      {!!heading && <div className="heading-5 mb-0_75">{heading}</div>}
      <ul
        className="list-unstyled m-0 medium d-flex flex-wrap"
        style={{
          columnGap: '0.5rem',
          rowGap: '0.5rem',
        }}
      >
        {submodelsArray.map(({ id, value, slug }) => (
          <li className="d-flex" key={id}>
            {id === currentSubmodelId ? (
              <div className="submodel-btn px-1 py-0_5 bg-white submodel-current fw-medium text-primary-darker">
                {value}
              </div>
            ) : (
              <Link
                to={getCoreUrl({
                  makeSlug: params.make,
                  modelSlug: params.model,
                  year: params.year,
                  submodelSlug: slug,
                })}
                className="submodel-btn px-1 py-0_5 bg-white"
                data-tracking-id="type_select"
                data-tracking-value={id}
              >
                {value}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

OtherSubmodelsUI.propTypes = {
  params: CorePageParams.isRequired,
  className: PropTypes.string,
  heading: PropTypes.string,
  submodels: PropTypes.arrayOf(PropTypes.shape({ slug: PropTypes.string, name: PropTypes.string })),
  currentSubmodelId: PropTypes.string,
};

export const OtherSubmodels = connectToModel(OtherSubmodelsUI, {
  submodels: bindToPath(({ params }) => buildSubmodelsPath(params), VehicleGraphQLModel),
});
